import { UPDATE_STATUS_BEGIN, UPDATE_STATUS_FAILURE, UPDATE_STATUS_SUCCESS } from './statusActions';

const initialState = {
  loading: false,
  error: null,
};

export default function statusReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_STATUS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
